/**
 * PresentationFolderView React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';
import PresentationFileView from "./PresentationFileView";
import PresentationAbstractView from "./PresentationAbstractView";


/**
 * presentation folder view
 *
 * @author Jens Gruschel
 */
function PresentationFolderView(props) {

    const navigationIndex = props.navigationIndex || [];
    const rootNavigationIndex = navigationIndex[0];

    if (!rootNavigationIndex) {

        return <PresentationAbstractView
            screenIndex={props.screenIndex}
            presentationFileOrFolder={props.presentationFolder}
            findReferencedObjects={props.findReferencedObjects}
        />;
    }
    else {

        const presentationFolder = props.presentationFolder || {};
        const presentationFolderFields = presentationFolder.fields || {};
        const presentationFileIndex = rootNavigationIndex - 1;
        const presentationFiles = presentationFolderFields['items'] || [];
        const presentationFileId = presentationFiles[presentationFileIndex];
        const presentationFile = props.findReferencedObjects(presentationFileId);

        return <PresentationFileView
            screenIndex={props.screenIndex}
            presentationFile={presentationFile}
            navigationIndex={navigationIndex.slice(1)}
            findReferencedObjects={props.findReferencedObjects}
            paused={props.paused}
            playbackPosition={props.playbackPosition}
            onPlaybackEnded={props.onPlaybackEnded}
        />;
    }
}

PresentationFolderView.propTypes = {
    screenIndex: PropTypes.number,
    presentationFolder: PropTypes.object,
    navigationIndex: PropTypes.arrayOf(PropTypes.number),
    findReferencedObjects: PropTypes.func.isRequired,
    paused: PropTypes.bool,
    playbackPosition: PropTypes.number,
    onPlaybackEnded: PropTypes.func
};

export default PresentationFolderView;
